import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Core2Config } from '../shared';
import { CpCommerceFormQuestionFieldValuesHdrContainerModel } from '../../../../../models/aggregates/website-form/cpcommerce-form-question-field-values-hdr-container.model';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';

@Injectable({
  providedIn: 'root'
})
export class CpCommerceFormQuestionFieldValuesHdrService extends BaseApiPublicLoginTemplateService<CpCommerceFormQuestionFieldValuesHdrContainerModel,CpCommerceFormQuestionFieldValuesHdrContainerModel,CpCommerceFormQuestionFieldValuesHdrContainerModel> {

  static readonly CP_COMMERCE_FORM_QUESTION_FIELD_VALUES_HDR_PATH = 'form-question-field-values-hdrs/';
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + Core2Config.CPCOMMERCE_PREFIX + CpCommerceFormQuestionFieldValuesHdrService.CP_COMMERCE_FORM_QUESTION_FIELD_VALUES_HDR_PATH  + BaseApiTemplateService.BACKOFFICE_EP;

  constructor(http: HttpClient) {
    super();
    this.httpClient = http;
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + Core2Config.CPCOMMERCE_PREFIX + CpCommerceFormQuestionFieldValuesHdrService.CP_COMMERCE_FORM_QUESTION_FIELD_VALUES_HDR_PATH  + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + Core2Config.CPCOMMERCE_PREFIX + CpCommerceFormQuestionFieldValuesHdrService.CP_COMMERCE_FORM_QUESTION_FIELD_VALUES_HDR_PATH  + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + Core2Config.CPCOMMERCE_PREFIX + CpCommerceFormQuestionFieldValuesHdrService.CP_COMMERCE_FORM_QUESTION_FIELD_VALUES_HDR_PATH  + BaseApiTemplateService.PUBLIC_EP;
  }
}

